import type { FC } from 'react'
import { memo, useRef } from 'react'
import { Avatar, type AvatarProps, Box, Skeleton, BareButton } from '@dhl-ui/components'
import { useApp } from '~/context/index.js'
import { useGetProfileInitials } from '~/profile/model/profile/hooks.js'

type Props = AvatarProps & {
  onClick?: () => void
}

/**
 *
 * TODO: candidate for DS
 * input should then support ref and src, since thats specific for RECEIVER but rest for it to
 * be nicely clickable is for DS
 */
export const ProfileAvatar: FC<Props> = memo(({ onClick, ...rest }: Props) => {
  const ref = useRef<HTMLDivElement | null>(null)
  const { data } = useGetProfileInitials()

  const { profileAvatar, isLoadingProfileAvatar } = useApp()

  return (
    <Box
      ref={ref}
      component={BareButton}
      sx={{
        cursor: 'pointer',
        borderRadius: '50%',
        outline: 0,
        '&:hover, &:focus-visible': { outline: '1px solid' },
        '&:hover': { outlineColor: 'light.states.hover' },
        '&:focus-visible': { outlineColor: 'light.states.focus', outlineWidth: ({ misc }) => misc.borderSize(2) },
      }}
      onClick={onClick}
    >
      {isLoadingProfileAvatar ? (
        <Skeleton variant="circular">
          <Avatar {...rest} />
        </Skeleton>
      ) : (
        <Avatar {...rest} src={profileAvatar}>
          {data ?? ''}
        </Avatar>
      )}
    </Box>
  )
})
